import React from "react";

export const ErrorView = (): React.ReactElement => {
  return <div>Oops</div>;
};
